import React from "react";
import FullPageLoader from "./fullPageLoader";

export default function RouteFallback() {
    const overlayActive =
        typeof document !== "undefined" && document.getElementById("__prehide");
    return overlayActive ? null : <FullPageLoader />;
}